import { api } from "../lib/api";

export interface SignConsentRequest {
	/**
	 * Durable backend task instance id. Prefer sending this when available —
	 * it disambiguates between multiple instances of the same `taskKey`
	 * (e.g. across journeys/steps). `taskKey` is retained for backward
	 * compatibility and as a fallback when no instance id is known.
	 */
	taskId?: string;
	taskKey: string;
	consentType: string;
	consentVersion: string;
	signerName?: string;
	signatureDataUrl: string;
	metadata?: Record<string, unknown>;
}

export interface SignConsentResponse {
	id: string;
	taskId: string;
	taskKey: string;
	consentType: string;
	consentVersion: string;
	signerName: string | null;
	signatureFileUrl: string;
	status: "signed" | "revoked" | "voided";
	signedAt: string;
}

export async function signConsent(
	payload: SignConsentRequest,
): Promise<SignConsentResponse> {
	const response = await api.post<SignConsentResponse>(
		"/api/consent-signatures",
		payload,
	);
	return response.data;
}
